module.exports = __webpack_public_path__ + "img/illustrator-vision.3b737bd2.svg";